import { render, staticRenderFns } from "./UserAdmin.vue?vue&type=template&id=2f329783&scoped=true"
import script from "./UserAdmin.vue?vue&type=script&lang=js"
export * from "./UserAdmin.vue?vue&type=script&lang=js"
import style0 from "./UserAdmin.vue?vue&type=style&index=0&id=2f329783&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f329783",
  null
  
)

export default component.exports